export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CLEAN_USER = 'CLEAN_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_USER_FETCHING = 'SET_USER_FETCHING';

export const SAVE_LAWS_ALL_PUB_USER_FILTERS = 'SAVE_LAWS_ALL_PUB_USER_FILTERS';
export const DELETE_LAWS_ALL_PUB_USER_FILTERS = 'DELETE_LAWS_ALL_PUB_USER_FILTERS';
export const SET_LAWS_ALL_PUB_USER_FILTERS_SAVING = 'SET_LAWS_ALL_PUB_USER_FILTERS_SAVING';

export const SAVE_LAWS_MY_FAV_USER_FILTERS = 'SAVE_LAWS_MY_FAV_USER_FILTERS';
export const DELETE_LAWS_MY_FAV_USER_FILTERS = 'DELETE_LAWS_MY_FAV_USER_FILTERS';
export const SET_LAWS_MY_FAV_USER_FILTERS_SAVING = 'SET_LAWS_MY_FAV_USER_FILTERS_SAVING';

export const SAVE_LAWS_MY_ACTIONS_USER_FILTERS = 'SAVE_LAWS_MY_ACTIONS_USER_FILTERS';
export const DELETE_LAWS_MY_ACTIONS_USER_FILTERS = 'DELETE_LAWS_MY_ACTIONS_USER_FILTERS';
export const SET_LAWS_MY_ACTIONS_USER_FILTERS_SAVING = 'SET_LAWS_MY_ACTIONS_USER_FILTERS_SAVING';

export const SAVE_LAWS_WAITING_USER_FILTERS = 'SAVE_LAWS_WAITING_USER_FILTERS';
export const DELETE_LAWS_WAITING_USER_FILTERS = 'DELETE_LAWS_WAITING_USER_FILTERS';
export const SET_LAWS_WAITING_USER_FILTERS_SAVING = 'SET_LAWS_WAITING_USER_FILTERS_SAVING';

export const COMPUTE_INITIAL_USER_FILTERS = 'COMPUTE_INITIAL_USER_FILTERS';

export const CHANGE_THEME = 'CHANGE_THEME';



// WEBPACK FOOTER //
// ./src/redux_related/user/actions.js